export default "<p>\r\n    Logging in...\r\n</p>"